import React, { Component } from 'react'

import { connect } from 'react-redux'
import {
  clearFilterOptionValues,
  updateFormOptions,
  checkValidity,
  extractFilterOptions,
  getSelectvalue,
  updateObject,
  applyRecordDataToForm,
  validateForm
} from '../../../../helpers/utils'
import ItemSelectorContent from '../../../../components/PageContent/Assignment/ItemSelectorContent/ItemSelectorContent'
import * as actions from '../../../../store/actions'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import { intersection } from 'lodash'

class ItemSelector extends Component {
  state = {
    form: {
      form_id: {
        label: this.props.translate('form'),
        value: '',
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: [],
          disabled: false
        },
        validation: {
          required: true
        },
        valid: false,
        error: null,
        touched: false
        // loading: true
      },
      criteria_id: {
        label: this.props.translate('criteria'),
        value: '',
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('criteria'),
          options: [],
          disabled: false
        },
        validation: {
          required: true
        },
        valid: false,
        error: null,
        touched: false
        // loading: true
      }
    },
    currentStructure: null,
    selectedStructures: [],
    selectedItems: [],
    selectedTags: [],
    continued: false,
    submitDisabled: true,
    formOptions: [],
    criteriaOptions: [],
    assignmentItemsCache: [],
    itemIdsCache: []
  }

  componentDidMount() {
    const {
      appraisalType,
      assignmentInfo,
      assignmentTargetIds,
      assignmentFilter,
      history
    } = this.props
    let redirectPath = null
    let updatedForm = { ...this.state.form }

    if (!appraisalType && !assignmentInfo) {
      // Case access without passing any assignment card list page (random access)
      return history.replace('/assignment/individual')
    } else if (!assignmentInfo && assignmentTargetIds?.length < 1) {
      // Case access without selecting any assignment target
      if (appraisalType?.appraisal_type_code === 'APT02') {
        redirectPath = '/assignment/individual'
      } else {
        redirectPath = '/assignment/corporate'
      }

      return history.replace(redirectPath)
    } else if (assignmentInfo) {
      const mappedData = applyRecordDataToForm(this.state.form, assignmentInfo, {
        eachApplyCallback: (appliedKey, appliedItem) => {
          const remoteValue = assignmentInfo[appliedKey]
          let elementConfig = appliedItem?.elementConfig
          let value = appliedItem.value
          let valid = false

          if (value || remoteValue) {
            elementConfig = { ...elementConfig, disabled: true }
            valid = appliedItem.valid
          }

          appliedItem = { ...appliedItem, value, elementConfig, valid }

          return appliedItem
        }
      })

      updatedForm = mappedData
    }

    this.setState({
      form: updatedForm
    })

    this.props.fetchDropdownOptions({
      appraisal_type_id: appraisalType?.appraisal_type_id,
      ...assignmentFilter,
      form_id: this.state.form.form_id.value?.value || assignmentInfo?.form_id,
      criteria_id: this.state.form.criteria_id.value?.value || assignmentInfo?.criteria_id,
      assign_target: assignmentTargetIds
    })
  }

  static getDerivedStateFromProps(props, state) {
    let updatedState = {}
    if (props.criteriaOptions !== state.criteriaOptions) {
      const value = +props.assignmentInfo?.criteria_id
      const formItem = { ...state.form.criteria_id }
      const updatedFormItem = updateFormOptions(
        props.criteriaOptions,
        formItem,
        'criteria_id',
        'criteria_id',
        'criteria_name',
        props.translate('select') + props.translate('criteria')
      )

      const selected = getSelectvalue(value, updatedFormItem.elementConfig.options)

      if (selected) {
        props.fetchStructures(
          {
            appraisal_type_id: +props.assignmentInfo?.appraisal_type_id,
            form_id: +props.assignmentInfo?.form_id,
            company_id: +props.assignmentInfo?.company_id,
            level_group_id:
              +props.assignmentInfo?.level_group_id || props.assignmentFilter?.level_group_id,
            criteria_id: value,
            assign_target: props.assignmentTargetIds
          },
          true
        )
      }

      updatedState = {
        ...updatedState,
        form: updateObject(updatedState.form || state.form, {
          criteria_id: { ...updatedFormItem, value: selected }
        }),
        criteriaOptions: props.criteriaOptions
      }
    }
    if (props.formOptions !== state.formOptions) {
      const formItem = { ...state.form.form_id }
      const value = +props.assignmentInfo?.form_id || +props.assignmentFilter?.form_id
      const updatedFormItem = updateFormOptions(
        props.formOptions,
        formItem,
        'form_id',
        'form_id',
        'form_name',
        props.translate('select') + props.translate('form')
      )

      const selected = getSelectvalue(value, updatedFormItem.elementConfig.options)

      updatedState = {
        ...updatedState,
        form: updateObject(updatedState.form || state.form, {
          form_id: { ...updatedFormItem, value: selected, valid: !!selected }
        }),
        formOptions: props.formOptions
      }
    }
    if (props.selectedAssignmentItemIds !== state.itemIdsCache) {
      updatedState = {
        ...updatedState,
        selectedItems: props.selectedAssignmentItemIds,
        itemIdsCache: props.selectedAssignmentItemIds
      }
    }
    return updatedState
  }

  componentWillUnmount() {
    this.clearFilterForm()
    this.clearSelectedItems()
    this.props.clearStructure()
    this.props.setAssignAction('general')
    if (!this.state.continued) {
      this.props.clearAssignmentItems()
    }
    this.setState({
      continued: false
      // submitDisabled: true
    })
  }

  clearFilterForm = () => {
    const updatedFilters = clearFilterOptionValues(this.state.form)
    this.setState({
      filterControls: updatedFilters
    })
  }

  clearSelectedItems = () => {
    this.setState({
      selectedItems: [],
      selectedStructures: [],
      currentStructure: null
    })
  }

  // Filter Actions
  inputChangedHandler = (formKey, event) => {
    let value = event
    const form = { ...this.state.form }

    const { isValid, error } = checkValidity(value, form[formKey].validation, form[formKey].label)

    const updatedItem = { ...form[formKey], value, valid: isValid, error, touched: true }
    let updatedForm = updateObject(form, { [formKey]: updatedItem })

    if (formKey === 'criteria_id') {
      if (value) {
        this.props.fetchStructures({
          appraisal_type_id: +this.props.assignmentInfo?.appraisal_type_id,
          form_id: this.state.form.form_id.value?.value,
          criteria_id: value?.value,
          company_id: this.props.assignmentFilter?.company_id,
          level_group_id: this.props.assignmentFilter?.level_group_id,
          assign_target: this.props.assignmentTargetIds
        })
      }
      this.setState({
        selectedStructures: [],
        selectedItems: [],
        currentStructure: null
      })
      this.props.setAssignmentItems([])
    }

    this.setState({
      form: updatedForm
    })
  }

  // Structure and items actions
  structureSelectedHandler = structure => {
    this.setState({
      currentStructure: structure
    })
  }

  itemSelectedHandler = eventItem => {
    const {
      // selectedStructures, currentStructure,
      selectedItems
    } = this.state

    const itemExists = selectedItems.includes(+eventItem.item_id)

    let updatedItems = null
    if (itemExists) {
      updatedItems = selectedItems.filter(itemId => +itemId !== +eventItem.item_id)
    } else {
      updatedItems = [...selectedItems, +eventItem.item_id]
    }

    this.setState({
      selectedItems: updatedItems
      // selectedStructures: updatedStructures
    })
  }

  tagSelectedHandler = (tags, targetGroupCode) => {
    this.setState(({ selectedTags }) => {
      const updatedTags = { ...selectedTags, [targetGroupCode]: tags }
      return {
        selectedTags: updatedTags
      }
    })
  }

  itemsAddedHandler = () => {
    const selectedItemIds = this.state.selectedItems
    const selectedTags = this.state.selectedTags

    const selectedTagItemIds = this.props.structures.reduce((tagItemIds, structure) => {
      const structureCode = structure.structure_type.value_list_code
      if (structureCode === 'STT05') {
        const tagItemIds = Object.entries(structure.items).flatMap(group => {
          const [groupKey, groupAttrs] = group
          const items = groupAttrs.items
            .filter(item => intersection(item.tags, selectedTags[groupKey]).length)
            .map(item => item.item_id)
          return items
        })
        return [...tagItemIds, ...tagItemIds]
      }
      return tagItemIds
    }, [])

    const itemIdsSet = new Set([...selectedItemIds, ...selectedTagItemIds])
    const mergedItems = Array.from(itemIdsSet)

    this.props.setAssignmentItems(mergedItems)
  }

  itemRemovedHandler = selectedItemId => {
    const updatedList = this.state.selectedItems.filter(itemId => +itemId !== +selectedItemId)
    this.props.setAssignmentItems(updatedList)
  }

  // Submitted
  submittedHandler = () => {
    const data = extractFilterOptions(this.state.form)
    if (this.props.assignmentAction === 'export') {
      let redirectPath = '/assignment/individual'
      if (this.props.appraisalType?.appraisal_type_code === 'APT01') {
        redirectPath = '/assignment/corporate'
      }
      const { company_id, appraisal_type_id } = this.props.assignmentInfo
      const exportInfo = {
        company_id,
        appraisal_type_id,
        ...data,
        assign_target: this.props.assignmentTargetIds,
        selected_item_ids: this.props.selectedAssignmentItemIds
      }
      this.props.exportAssignmentData(exportInfo)
      this.props.history.replace(redirectPath)
    } else {
      let redirectPath = '/assignment/assign'
      let selectedItems = this.props.selectedAssignmentItemIds

      let options = {
        ...data,
        appraisal_type_id: +this.props.assignmentInfo?.appraisal_type_id,
        company_id: +this.props.assignmentInfo?.company_id,
        level_group_id:
          +this.props.assignmentInfo?.level_group_id ||
          +this.props.assignmentFilter?.level_group_id,
        assignTarget: this.props.assignmentTargetIds,
        selectedItemIds: selectedItems,
        deployItemIds: this.props.deployItemIds
      }
      this.props.fetchAssignmentData(options)
      this.props.setAssignmentData(data)

      if (this.props.assignmentInfo?.result_id) {
        redirectPath = `/assignment/${this.props.assignmentInfo.result_id}`
      }

      this.setState(
        {
          continued: true
        },
        () => {
          this.props.history.replace(redirectPath)
        }
      )
    }
  }

  // Cancelled
  cancelledHandler = () => {
    let redirectPath = ''
    if (this.props.location.state?.fromAssignPage) {
      this.setState(
        {
          continued: true
        },
        () => {
          if (this.props.assignmentInfo?.result_id) {
            redirectPath = `/assignment/${this.props.assignmentInfo.result_id}`
          } else {
            redirectPath = '/assignment/assign'
          }
          this.props.history.replace(redirectPath)
        }
      )
    } else {
      const appraisalType = this.props.appraisalType
      redirectPath = '/assignment/individual'

      if (appraisalType) {
        if (appraisalType.appraisal_type_code === 'APT02') {
          redirectPath = '/assignment/individual'
        } else if (appraisalType.appraisal_type_code === 'APT01') {
          redirectPath = '/assignment/corporate'
        }
      }

      this.setState(
        {
          continued: false
        },
        () => this.props.history.replace(redirectPath)
      )
    }
  }

  getSubmitDisabledState = (form, selectedItems) => {
    const formValid = validateForm(form)
    const action = this.props.assignmentAction
    if (action === 'export') {
      return !formValid
    }
    return !formValid || selectedItems.length < 1
  }

  render() {
    const { structures, selectedAssignmentItemIds } = this.props
    const targetItems = structures.reduce((selectedItems, structure) => {
      let items = []

      if (structure.structure_type.value_list_code !== 'STT05') {
        items = structure.items
          .filter(item => selectedAssignmentItemIds.includes(+item.item_id))
          .map(item => ({
            ...item,
            structure_id: structure.structure_id,
            structure_name: structure.structure_name
          }))
      } else {
        items = Object.entries(structure.items).flatMap(group => {
          const [, groupAttrs] = group
          return groupAttrs.items
            .filter(item => selectedAssignmentItemIds.includes(item.item_id))
            .map(item => ({
              ...item,
              structure_id: structure.structure_id,
              structure_name: structure.structure_name
            }))
        })
      }

      return [...selectedItems, ...items]
    }, [])
    return (
      <Aux>
        <Alert />
        <ItemSelectorContent
          form={this.state.form}
          inputChanged={this.inputChangedHandler}
          currentStructure={this.state.currentStructure}
          structureList={this.state.form.criteria_id.value ? this.props.structures : []}
          // selectedStructures={this.state.selectedStructures}
          selectedItems={this.state.selectedItems}
          selectedTags={this.state.selectedTags}
          targetItems={targetItems}
          onTagSelected={this.tagSelectedHandler}
          onStructureSelected={this.structureSelectedHandler}
          onItemSelected={this.itemSelectedHandler}
          onItemsAdded={this.itemsAddedHandler}
          onItemDeleted={this.itemRemovedHandler}
          submitDisabled={
            this.getSubmitDisabledState(this.state.form, this.state.selectedItems) ||
            !this.props.pagePermission.is_edit
          }
          submitted={this.submittedHandler}
          cancelled={this.cancelledHandler}
        />
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    appraisalType: state.assignmentFlow.appraisalType,
    assignmentTargetIds: state.assignmentFlow.assignmentTargetIds,
    structures: state.assignmentFlow.structures,
    selectedAssignmentItems: state.assignmentFlow.assignmentItems,
    selectedAssignmentItemIds: state.assignmentFlow.assignmentItemIds,
    deployItemIds: state.assignmentFlow.deployItemIds,
    continued: state.assignmentFlow.continued,
    formOptions: state.assignmentFlow.forms,
    criteriaOptions: state.assignmentFlow.criteria,
    assignmentFilter: state.assignmentFlow.filter,
    assignmentInfo: state.assignmentFlow.assignmentInfo,
    // assignmentData: state.assignmentFlow.assignmentData,
    assignmentAction: state.assignmentFlow.action
  }
}

const mapDispatchToProps = dispatch => ({
  setAssignAction: action => dispatch(actions.setAssignmentAction(action)),
  setAssignmentItems: items => dispatch(actions.setAssignItems(items)),
  setAssignmentData: data => dispatch(actions.setAssignmentData(data)),
  clearAssignmentItems: () => dispatch(actions.clearAssignmentItems()),
  fetchDropdownOptions: filterOptions => {
    dispatch(actions.fetchFormOptionsForAppraisal())
    dispatch(actions.fetchCriteriaOptionsForAppraisal(filterOptions))
  },
  fetchStructures: (filterOptions, isEdit) => {
    dispatch(actions.fetchStructureWithItems(filterOptions, isEdit))
  },
  exportAssignmentData: exportData => {
    dispatch(actions.exportAssignmentData(exportData))
  },
  fetchAssignmentData: assignmentOptions => {
    dispatch(actions.fetchAssignmentDataTemplate({ ...assignmentOptions }))
  },
  clearStructure: () => {
    dispatch(actions.clearAssignmentStructure())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ItemSelector))
